import { WebPlugin } from '@capacitor/core';
export class StreamHttpWeb extends WebPlugin {
    async startStream(_options) {
        console.warn('StreamHttp plugin is not implemented on web');
        throw new Error('StreamHttp plugin is not implemented on web');
    }
    async cancelStream(_options) {
        console.warn('StreamHttp plugin is not implemented on web');
        throw new Error('StreamHttp plugin is not implemented on web');
    }
}
//# sourceMappingURL=web.js.map